import { render, staticRenderFns } from "./vActions.vue?vue&type=template&id=f4627dc8&scoped=true"
import script from "./vActions.vue?vue&type=script&lang=js"
export * from "./vActions.vue?vue&type=script&lang=js"
import style0 from "./vActions.vue?vue&type=style&index=0&id=f4627dc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4627dc8",
  null
  
)

export default component.exports